module.exports = __webpack_public_path__ + "img/feature-split-02.4d323848.jpg";